import { render, staticRenderFns } from "./HomeSignUp.vue?vue&type=template&id=38104a68"
import script from "./HomeSignUp.vue?vue&type=script&lang=js"
export * from "./HomeSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports